import React, { useState } from 'react';
import { IconButton, Stack, TextField, Tooltip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { ts } from 'src/utils/translate';

const LIST_NAME_MAX_LENGTH = 50;

type Props = {
    initialValue?: string;
    disabled: boolean;
    confirmTooltip: string;
    cancelTooltip: string;
    onConfirm: (name: string) => void;
    onCancel: () => void;
};

export const ParticipantListNameInput = ({ initialValue = '', disabled, confirmTooltip, cancelTooltip, onConfirm, onCancel }: Props) => {
    const [name, setName] = useState(initialValue);

    return (
        <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1 }}>
            <TextField
                size="small"
                fullWidth
                autoFocus
                onFocus={(event) => event.target.select()}
                placeholder={ts('list_name_placeholder', 'List name')}
                value={name}
                disabled={disabled}
                slotProps={{ htmlInput: { maxLength: LIST_NAME_MAX_LENGTH } }}
                onChange={(event) => setName(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') onConfirm(name);
                    else if (event.key === 'Escape') onCancel();
                }}
            />
            <Tooltip title={confirmTooltip}>
                <span>
                    <IconButton size="small" color="primary" disabled={disabled} onClick={() => onConfirm(name)}>
                        <CheckIcon />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={cancelTooltip}>
                <span>
                    <IconButton size="small" disabled={disabled} onClick={onCancel}>
                        <CloseIcon />
                    </IconButton>
                </span>
            </Tooltip>
        </Stack>
    );
};
